<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <transition name="fade">
          <div class="wrapper" v-if="textPageTitle">
            <div class="title">
              {{ textPageTitle }}
            </div>
            <div class="desc" v-html="textPageHeader"></div>
            <div class="desc" v-html="textPageContent"></div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "TextPage",
  props: [],
  components: {},
  data: function () {
    return {
      textPageTitle: "",
      textPageHeader: "",
      textPageContent: "",
    };
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.getTextPageContent(this.$route.params.id);
      } else {
        this.$http.get(process.env.VUE_APP_API + "static-pages").then((res) => {
          let newList = res.data.payload;
          let newItem = newList.filter(
            (item) =>
              item.title.replace(/ /g, "_").toLowerCase() ==
              this.$route.params.title
          );
          this.getTextPageContent(newItem[0].id);
        });
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getTextPageContent(this.$route.params.id);
    } else {
      this.$http.get(process.env.VUE_APP_API + "static-pages").then((res) => {
        let newList = res.data.payload;
        let newItem = newList.filter(
          (item) =>
            item.title.replace(/ /g, "_").toLowerCase() ==
            this.$route.params.title
        );
        this.getTextPageContent(newItem[0].id);
      });
    }
  },
  methods: {
    getTextPageContent(id) {
      this.textPageTitle = "";
      this.textPageHeader = "";
      this.textPageContent = "";
      this.$http
        .get(process.env.VUE_APP_API + "static-pages/" + id)
        .then((res) => {
          this.textPageTitle = res.data.payload.title;
          this.textPageContent = res.data.payload.content;
          this.textPageHeader = res.data.payload.header;
        });
    },
  },
};
</script>
